; (function () {
    'use strict';

    var app = angular.module('tunnel', [
        'ui.router'
    ]);

    var componentFolders = ({"connected":({"beneficiaire":({"beneficiaire-detail.component":require("./connected\\beneficiaire\\beneficiaire-detail.component.js"),"beneficiaire-form.component":require("./connected\\beneficiaire\\beneficiaire-form.component.js"),"beneficiaire-row.component":require("./connected\\beneficiaire\\beneficiaire-row.component.js"),"beneficiaire-sort.component":require("./connected\\beneficiaire\\beneficiaire-sort.component.js"),"beneficiaire":require("./connected\\beneficiaire\\beneficiaire.js")}),"connected":require("./connected\\connected.js"),"descriptif":({"descriptif.component":require("./connected\\descriptif\\descriptif.component.js"),"descriptif":require("./connected\\descriptif\\descriptif.js")}),"factures":({"factures.component":require("./connected\\factures\\factures.component.js"),"factures":require("./connected\\factures\\factures.js")}),"parametrage":({"parametrage.component":require("./connected\\parametrage\\parametrage.component.js"),"parametrage":require("./connected\\parametrage\\parametrage.js")}),"recapitulatif":({"recapitulatif-connected.component":require("./connected\\recapitulatif\\recapitulatif-connected.component.js"),"recapitulatif":require("./connected\\recapitulatif\\recapitulatif.js")}),"sidebar.component":require("./connected\\sidebar.component.js"),"timeline":({"timeline.component":require("./connected\\timeline\\timeline.component.js"),"timeline":require("./connected\\timeline\\timeline.js")})}),"forgotpassword":({"forgotpassword-emailsent.component":require("./forgotpassword\\forgotpassword-emailsent.component.js"),"forgotpassword-reinit.component":require("./forgotpassword\\forgotpassword-reinit.component.js"),"forgotpassword.component":require("./forgotpassword\\forgotpassword.component.js"),"forgotpassword":require("./forgotpassword\\forgotpassword.js")}),"login":({"activationExpired.component":require("./login\\activationExpired.component.js"),"login.component":require("./login\\login.component.js"),"login":require("./login\\login.js")}),"tunnel":require("./tunnel.js")});

    for (var prop in componentFolders) {
        if (prop.indexOf('component') != -1) {
            app.component(componentFolders[prop].name, componentFolders[prop].obj);
        }
    }

    app.config(function ($stateProvider) {
        $stateProvider.state('tunnel', {
            abstract: true,
            url: '',
            views: {
                'wrapper': {
                    template: '<div ui-view="content"></div>',
                    controller: function (localStorageService, Ressources, wordings) {
                        /* WORDING */
                        if (!localStorageService.get(Ressources.WORDING_KEY)) {
                            localStorageService.set(Ressources.WORDING_KEY, wordings);
                        }
                    }
                },
                'header': {
                    template: '<header-tunnel></header-tunnel>'
                }
            },
            resolve: {
                wordings: function (WordingService, localStorageService, Ressources) {
                    var wordings = localStorageService.get(Ressources.WORDING_KEY);
                    return wordings ? wordings : WordingService.allWording().then(function (result) {
                        return result;
                    });
                }
            }
        });
    });

    module.exports = app;
})();